import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "tv_dich_vu";

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm,
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.delete = (id) => {
    let api = {
        module: moduleName,
        type: "delete",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.unApprovedDichVu = (id) => {
    let api = {
        module: moduleName,
        type: "unApprovedDichVu",
        value: { id: id },
        message: {
            success: "Bỏ duyệt dịch vụ thành công", //string | null | comment
            error: "Bỏ duyệt dịch vụ không thành công", //string | null | comment
        },
    };
    return ApiService(api);
};


export default moduleApi;